export default "__VITE_ASSET__COpdvtOG__"